import dynamic from 'next/dynamic';

import { type BlokItem, sbEditable, type SBProps } from '../../../../utils';

const DynamicRender = dynamic(() => import('../../../../utils').then(mod => mod.DynamicRender));

interface SBServiceCardItemProps {
  // This is not independent component, title is used in SBServiceList
  title: string;
  subtitle?: string;
  body?: string;
  cta?: BlokItem[];
}

export const SBServiceCardItem = ({ blok }: SBProps<SBServiceCardItemProps>) => {
  const { body, subtitle, cta } = blok;

  return (
    <div className="grid gap-4 lg:gap-6" {...sbEditable(blok)}>
      {subtitle && <p className="text-lg font-semibold lg:text-2xl">{subtitle}</p>}
      {body && <p className="text-gray-600 lg:text-lg">{body}</p>}
      {cta && <DynamicRender data={cta} />}
    </div>
  );
};
